/**
 * Created by Ram on 19/01/2017.
 */

import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { MenuItem, Select } from "@material-ui/core"

export default class CustomerSignup extends Component {
    render() {
        const accountType = ['Production', 'POC', 'Prospect', 'Internal']
        return (
            <div>
                <div className="text-center user-forms no-max-width navbar-default">
                    <h2>Create Customer Account</h2>
                    <Modal show={this.props.showModal} onHide={this.props.closeModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Customer Account Created</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div><p>The Account has been created.</p></div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button bsStyle="primary" bsSize="large" onClick={this.props.closeModal}>Return to Account list</Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={this.props.errorMessage?true:false} onHide={this.props.closeModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Error in creating Account</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div><p style={{color: "red"}}>{this.props.errorMessage}</p></div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button bsStyle="primary" bsSize="large" onClick={this.props.closeModal}>Close</Button>
                        </Modal.Footer>
                    </Modal>

                    <form data-toggle="validator" role="form">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="form-group col-sm-10 col-sm-offset-1">
                                    <label htmlFor="organisationName" className="pull-left"><h5>Customer Account *</h5></label>
                                    <input type="text" className="form-control" id="organisationName" name="organisationName" placeholder="Customer Account Name" onChange={this.props.updateFormState} />
                                    <div className="help-block with-errors"></div>
                                </div>
                                <div className="form-group col-sm-10 col-sm-offset-1">
                                    <label htmlFor="accountType" className="pull-left"><h5>Account Type *</h5></label>
                                    <Select
                                        name='accountType'
                                        onChange={this.props.updateFormState}
                                        placeholder='Select Account Type'
                                        fullWidth={true}
                                    >
                                        {accountType.map((type) => (
                                            <MenuItem key={type} value={type}>
                                                {type}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <div className="help-block with-errors"></div>
                                </div>
                                <div className="form-group col-sm-4 col-sm-offset-7">
                                    <button type="button" className="btn btn-primary pull-right" onClick={this.props.onCreateAccount}>Create Account</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}